export const flattenObject = (v, prefix = '', postfix = '') => {
  if(!v){
    return {}
  }

  const entries = Object.entries(v)
  const res = entries.reduce((obj, item) => Object.assign(obj, { [`${prefix}${item[0]}${postfix}`] : item[1] }), {})

  return res
}